import { MantineProvider, type CSSVariablesResolver } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { getConfigInterceptors } from './api/getConfigInterceptors'
import { client as hrmClient } from './api/hrm/client.gen'
import { client as intranetClient } from './api/intranet/client.gen'
import { queryClient } from './queryClient'
import { router } from './router'
import { theme } from './theme'
import { GlobalStyles } from './theme/GlobalStyles'

import '@mantine/core/styles.css'
import '@mantine/dates/styles.layer.css'
import '@mantine/notifications/styles.css'

hrmClient.setConfig({ baseURL: import.meta.env.VITE_APP_HRM_API })
intranetClient.setConfig({ baseURL: import.meta.env.VITE_APP_INTRANET_API })

getConfigInterceptors(hrmClient?.instance)
getConfigInterceptors(intranetClient?.instance)

// #495057 = gray.7 (~7:1 vs white); overrides gray-6 default which fails WCAG AA
const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: { '--mantine-color-dimmed': '#495057' },
  light: { '--mantine-color-dimmed': '#495057' },
  dark: { '--mantine-color-dimmed': '#ced4da' }
})

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver}>
      <GlobalStyles />
      <Notifications position="top-right" autoClose={1000} />
      <RouterProvider router={router} />
    </MantineProvider>
  </QueryClientProvider>
)
